import { makeStyles } from '@material-ui/core/styles';

export const myStyles = makeStyles(theme => ({
    editBtn: {
        padding: '5.5px 16px',
        marginLeft: 10,
    },
}));
